module.exports = __webpack_public_path__ + "Flag-308.9c0480cc99bf6a1b8ca058e7270de03c.svg";